var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
if(type == 'error') {
__p+='\n<br>\n<div class="alert error-msg error_box visible"><img src="' + require("/builds/landfx/Land-FX/assets/common/mypage/img/common/alert_fail.png") + '"><span>'+
((__t=(msg))==null?'':__t)+
'</span></div>\n';
} else {
__p+='\n<br>\n<div class="alert success-msg success_box visible"><img src="' + require("/builds/landfx/Land-FX/assets/common/mypage/img/common/alert_success.png") + '">'+
((__t=(msg))==null?'':__t)+
'</div>\n';
}
__p+='';
}
return __p;
};
